var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message"},[_c('message-preview',{attrs:{"index":0,"action":"expanded"}}),_c('message-display',{attrs:{"index":"0"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }